import { gql } from '@grandvisionhq/graphql';

const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription(
    $subscriptionId: String!
    $cancelDate: Date!
    $cancelReason: String!
  ) {
    cancelSubscription(
      subscriptionId: $subscriptionId
      cancelDate: $cancelDate
      cancelReason: $cancelReason
    ) {
      success
      failures {
        ... on SubscriptionNotFoundFailure {
          __typename
          message
        }
        ... on UnauthorizedFailure {
          __typename
          message
        }
        ... on InvalidTerminationDateFailure {
          message
        }
      }
    }
  }
`;

export { CANCEL_SUBSCRIPTION };
//# sourceMappingURL=cancel-subscription.js.map
